import {round} from 'lodash';

export class MathUtil {
    public static roundOff(number: number): number {
        return round(number, 2);
    }
}
